export const startRecording = (mediaStream, setMediaRecorder, CloseCameraForever = false) => {
  if (!mediaStream || CloseCameraForever) return;
  const recorder = new window.MediaRecorder(mediaStream, {
    mimeType: "video/webm",
  });
  let chunks = [];
  recorder.ondataavailable = (e) => {
    if (e.data.size > 0) chunks.push(e.data);
  };
  recorder.onstop = () => {
    const blob = new Blob(chunks, { type: "video/webm" });
  };
  recorder.start();
  setMediaRecorder(recorder);
};

export const stopRecording = (mediaRecorder) => {
  if (mediaRecorder) {
    mediaRecorder.stop();
  }
};

export const formatTime = (ms) => {
  if (ms <= 0) return "00:00:00";
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
}
